import { render, staticRenderFns } from "./CampaignPackageForm.vue?vue&type=template&id=61f6c100"
import script from "./CampaignPackageForm.vue?vue&type=script&lang=js"
export * from "./CampaignPackageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports